import { createContext, useContext, useState } from "react";

const BPCustomBottlerSelectionContext = createContext();

// Context Provider Component
export const BPCustomBottlerSelectionProvider = ({ children }) => {
  const [customSelectedData, setCustomSelectedData] = useState([]);

  return (
    <BPCustomBottlerSelectionContext.Provider
      value={{ customSelectedData, setCustomSelectedData }}
    >
      {children}
    </BPCustomBottlerSelectionContext.Provider>
  );
};

// Custom Hook for easy access
export const useBPCustomBottlerSelection = () =>
  useContext(BPCustomBottlerSelectionContext);
